import { exitSearch } from '../actions/exitSearch';
import { setShowListPane, setShowReadingPane } from 'owa-mail-layout';
import getSelectedTableView from 'owa-mail-list-store/lib/utils/getSelectedTableView';
import { lazyOnReadingPaneClosed } from 'owa-mail-mark-read-actions';
import { createLazyOrchestrator } from 'owa-bundling';
import { getSearchScenarioType } from 'owa-mail-list-search';
import { isReadingPanePositionOff } from 'owa-mail-layout/lib/selectors/readingPanePosition';
import { shouldShowReadingPane } from 'owa-mail-layout/lib/selectors/shouldShowReadingPane';
import { logUsage } from 'owa-analytics';
import closeImmersiveReadingPane from 'owa-mail-actions/lib/closeImmersiveReadingPane';

export const closeImmersiveReadingPaneOrchestrator = createLazyOrchestrator(
    closeImmersiveReadingPane,
    'closeImmersiveReadingPaneClone',
    actionMessage => {
        if (!isReadingPanePositionOff()) {
            throw new Error(
                'closeImmersiveReadingPane should only be called with reading pane off'
            );
        }

        const tableView = getSelectedTableView();
        const searchScenarioType = getSearchScenarioType(tableView.tableQuery);

        if (searchScenarioType === 'messageSuggestion') {
            // exit search on closing immersive reading pane if it's opened via
            // a message suggestion
            exitSearch('CommandBar');
            return;
        }

        const source = actionMessage.source || 'Unknown';
        logUsage('Immersive_ReadingPaneClosed', [source, searchScenarioType === 'mail']);

        const curShowReadingPane = shouldShowReadingPane();

        setShowListPane(true /* showListPane */);
        setShowReadingPane(false /* showReadingPane */);

        if (curShowReadingPane && tableView.selectedRowKeys.size == 1) {
            // Try perform the auto mark as read logic on user navigating away from single selected row
            const rowKey = [...tableView.selectedRowKeys.keys()][0];
            lazyOnReadingPaneClosed.importAndExecute(rowKey, tableView);
        }
    }
);
